export const tr = {
    BYN: 'BYN',
    CHF: '₣',
    EUR: '€',
    KZT: '₸',
    RUB: '₽',
    TRY: '₺',
    UAH: '₴',
    USD: '$',
    UZS: 'UZS',
    YND_FIXED: 'kredi'
};
